import { render, staticRenderFns } from "./agam_About.vue?vue&type=template&id=197b766c&"
import script from "./agam_About.vue?vue&type=script&lang=js&"
export * from "./agam_About.vue?vue&type=script&lang=js&"
import style0 from "./agam_About.vue?vue&type=style&index=0&id=197b766c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports